import fetchClient from './fetchClient';
import { errorHandler } from './utils';


const config = () => {
    return {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
        },
    };
};

export const getStock = async (category?: string): Promise<{ data: any; error: any }> => {
    const params = category && category !== 'all' ? { category } : {};
    const res: any = await fetchClient.get('/stock', { ...config(), params }).catch(errorHandler);
    if (res.error) return res;
    return { data: res ? res.data : null, error: null };
};

export const getLightStock = async (
    search: string = '',
    limit?: number,
    // Only set by order-creation pickers (manual/recurring/quick order). See
    // getProducts() in interfaces/products.tsx for why this isn't applied by default.
    forOrderPicker: boolean = false,
): Promise<{ data: any; error: any }> => {
    const params = new URLSearchParams();
    const term = (search || '').trim();
    if (term) params.set('search', term);
    if (Number.isFinite(limit) && (limit as number) > 0) {
        params.set('limit', String(limit));
    }
    if (forOrderPicker) params.set('forOrderPicker', 'true');
    const query = params.toString();
    const res: any = await fetchClient
        .get(`/stock/light${query ? `?${query}` : ''}`, config())
        .catch(errorHandler);
    if (res.error) return res;
    return { data: res ? res.data : null, error: null };
};

export const getLotNumbers = async (): Promise<{ data: any; error: any }> => {
    const res: any = await fetchClient
        .get('/stock/lot-numbers', config())
        .catch(errorHandler);
    if (res.error) return res;
    return { data: res ? res.data : null, error: null };
};

export const getLotNumbersTracking = async (
    id: string,
): Promise<{ data: any; error: any }> => {
    const res: any = await fetchClient
        .get(`/stock/tracking/${id}`, config())
        .catch(errorHandler);
    if (res.error) return res;
    return { data: res ? res.data : null, error: null };
};

export const getStockAlerts = async (): Promise<{ data: any; error: any }> => {
    const res: any = await fetchClient
        .get('/stock/alert', config())
        .catch(errorHandler);
    if (res.error) return res;
    return { data: res ? res.data : null, error: null };
};
